import ForgotCard from './Forgot';

export default ForgotCard;
